import { HTTP_STATUS_CODES } from "@/constants";
import { unauthorizedInterceptor } from "./unauthorizedInterceptor";

export const INTERCEPTORS_BY_HTTP_STATUS_CODE = {
  [HTTP_STATUS_CODES.UNAUTHORIZED]: unauthorizedInterceptor
};
